module.exports = "/images/offers.svg";